(function(){
'use strict';
var root=document.querySelector('[data-fmy-offers]');
if(!root||root.dataset.ready==='true')return;
root.dataset.ready='true';
var open=root.querySelector('[data-fo-open]'),dialog=root.querySelector('[data-fo-dialog]'),scrim=root.querySelector('[data-fo-scrim]'),close=root.querySelector('[data-fo-close]'),hide=root.querySelector('[data-fo-hide]'),active=false;
if(!open||!dialog||!scrim||!close)return;
var mq=window.matchMedia('(max-width:749px)');
try{if(sessionStorage.getItem('fmy-offers-hide-v1')==='yes')root.hidden=true}catch(e){}
function syncMode(){
  var mobile=mq.matches;
  dialog.setAttribute('aria-modal',mobile?'true':'false');
  scrim.hidden=!active||!mobile;
  document.body.classList.toggle('fmy-offers-lock',active&&mobile);
}
function show(){
  if(active)return;
  active=true;
  dialog.hidden=false;
  dialog.setAttribute('aria-hidden','false');
  open.setAttribute('aria-expanded','true');
  root.classList.add('fmy-offers--open');
  syncMode();
  dialog.focus();
  document.dispatchEvent(new CustomEvent('fourmytu:offers-open'));
}
function dismiss(restore){
  if(!active)return;
  active=false;
  dialog.hidden=true;
  dialog.setAttribute('aria-hidden','true');
  open.setAttribute('aria-expanded','false');
  root.classList.remove('fmy-offers--open');
  syncMode();
  if(restore!==false)open.focus();
}
open.addEventListener('click',show);
close.addEventListener('click',function(){dismiss(true)});
scrim.addEventListener('click',function(){dismiss(true)});
document.addEventListener('pointerdown',function(e){
  if(!active||mq.matches)return;
  if(!dialog.contains(e.target)&&!open.contains(e.target)&&!(hide&&hide.contains(e.target)))dismiss(false);
});
document.addEventListener('keydown',function(e){
  if(!active)return;
  if(e.key==='Escape'){e.preventDefault();dismiss(true);return}
  if(e.key!=='Tab'||!mq.matches)return;
  var nodes=Array.prototype.slice.call(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(n){return n.getClientRects().length});
  if(!nodes.length){e.preventDefault();dialog.focus();return}
  if(e.shiftKey&&(document.activeElement===nodes[0]||document.activeElement===dialog)){e.preventDefault();nodes[nodes.length-1].focus()}
  else if(!e.shiftKey&&document.activeElement===nodes[nodes.length-1]){e.preventDefault();nodes[0].focus()}
});
if(typeof mq.addEventListener==='function')mq.addEventListener('change',function(){if(active)syncMode()});
else if(typeof mq.addListener==='function')mq.addListener(function(){if(active)syncMode()});
if(hide)hide.addEventListener('click',function(){dismiss(false);root.hidden=true;try{sessionStorage.setItem('fmy-offers-hide-v1','yes')}catch(e){}});
/* Reopen this offers panel after a native Shopify newsletter form submission. */
var signupForm=dialog.querySelector('#fmy-offers-newsletter-form');
if(signupForm)signupForm.addEventListener('submit',function(){
  try{sessionStorage.setItem('fmy-offers-signup-pending','1')}catch(e){}
});
var signupPending=false;
try{
  signupPending=sessionStorage.getItem('fmy-offers-signup-pending')==='1';
  if(signupPending)sessionStorage.removeItem('fmy-offers-signup-pending');
}catch(e){}
if(signupPending){
  root.hidden=false;
  show();
}

/* Collapse Promo Pill on scroll; do not affect Classic Circle or the offer drawer. */
if(root.dataset.iconStyle==='promo_pill'){
  var scrollQueued=false;
  var compact=false;
  function syncPill(){
    scrollQueued=false;
    if(root.hidden)return;
    var y=window.pageYOffset||document.documentElement.scrollTop||0;
    var next=compact?(y>=80):(y>140);
    if(next===compact)return;
    compact=next;
    root.classList.toggle('fmy-offers--compact',compact);
  }
  function queuePill(){
    if(scrollQueued)return;
    scrollQueued=true;
    if(typeof window.requestAnimationFrame==='function')window.requestAnimationFrame(syncPill);
    else syncPill();
  }
  window.addEventListener('scroll',queuePill,{passive:true});
  syncPill();
}
syncMode();
})();